module.exports = __webpack_public_path__ + "static/media/retok.f6886fd2.jpg";